/** @jsxImportSource @emotion/react */
import CustomLabel from '@/components/custom-label';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import {
  getListAgeRange,
  watchListAge,
  watchListAgeLoading
} from '@/redux/slices/adivce-recommend.slice';
import { css } from '@emotion/react';
import { Form, Select } from 'antd';
import { useEffect, useMemo } from 'react';

type AdviceRecommendFilterProps = {
  value: FilterAdviceRecommend;
  onChange: (values: FilterAdviceRecommend) => void;
  adviceCateCode?: string;
};

export const AdviceRecommendFilter = ({
  value,
  onChange,
  adviceCateCode
}: AdviceRecommendFilterProps) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const ageRange = useAppSelector(watchListAge);
  const isLoading = useAppSelector(watchListAgeLoading);

  useEffect(() => {
    dispatch(getListAgeRange(adviceCateCode));
  }, [dispatch, adviceCateCode]);

  const ageOptions = useMemo(
    () => [
      ...ageRange.map((age) => ({
        value: age.ID,
        label: age.DESCRIPTION
      }))
    ],
    [ageRange]
  );

  useEffect(() => {
    form.setFieldsValue(value);
  }, [form, value]);

  useEffect(() => {
    if (ageOptions.length > 0) {
      onChange({ ageRange: ageOptions[0].value });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ageOptions]);

  return (
    <Form
      form={form}
      name='advice-recommend-filter'
      layout='inline'
      css={rootStyles}
      onValuesChange={(_, allValues) => onChange(allValues)}
    >
      <Form.Item
        label={CustomLabel({ text: 'Độ tuổi', isRequired: true })}
        name='ageRange'
      >
        <Select
          loading={isLoading}
          showSearch
          allowClear
          placeholder='Chọn độ tuổi'
          optionFilterProp='label'
          options={ageOptions}
          style={{ minWidth: 200 }}
        />
      </Form.Item>
    </Form>
  );
};

const rootStyles = css`
  .ant-form-item {
    margin-bottom: 0;
    margin-right: 0;

    .ant-form-item-label {
      padding-right: 12px;

      label {
        height: 32px;
        line-height: 32px;
        color: rgba(0, 0, 0, 0.88);
        font-weight: 400;

        &::after {
          content: '';
        }
      }
    }

    .ant-form-item-control {
      .ant-select {
        height: 32px;

        .ant-select-selector {
          height: 32px;
          padding: 4px 11px;

          .ant-select-selection-search-input {
            height: 24px;
          }

          .ant-select-selection-item {
            line-height: 24px;
          }
        }
      }
    }
  }
`;
